import type { LunimarRealm } from "@/components/lunimar/lunimarRealms";

export type Tone = "neutral" | "good" | "caution" | "danger" | "milestone" | "active";

export interface ToneStyle {
  fg: string;
  bg: string;
  border: string;
  label: string;
}

/**
 * Resolves a semantic outcome tone to color stops. Realm primary still
 * drives the "active" tone so each module's signature accent comes through.
 */
export function getTone(tone: Tone, realm?: LunimarRealm): ToneStyle {
  switch (tone) {
    case "good":
      return {
        fg: "152 70% 60%",
        bg: "152 70% 32% / 0.18",
        border: "152 70% 55% / 0.5",
        label: "Healthy",
      };
    case "caution":
      return {
        fg: "38 95% 60%",
        bg: "38 95% 32% / 0.18",
        border: "38 95% 55% / 0.5",
        label: "Tradeoff",
      };
    case "danger":
      return {
        fg: "0 78% 60%",
        bg: "0 78% 32% / 0.18",
        border: "0 78% 55% / 0.5",
        label: "Risk",
      };
    case "milestone":
      return {
        fg: "44 92% 62%",
        bg: "44 92% 32% / 0.18",
        border: "44 92% 55% / 0.5",
        label: "Progress",
      };
    case "active":
      return {
        fg: realm?.primaryAccent ?? "195 95% 62%",
        bg: `${realm?.primaryAccent ?? "195 95% 62%"} / 0.14`,
        border: `${realm?.primaryAccent ?? "195 95% 62%"} / 0.5`,
        label: "Active",
      };
    default:
      return {
        fg: "0 0% 100%",
        bg: "228 30% 20% / 0.4",
        border: "0 0% 100% / 0.12",
        label: "Neutral",
      };
  }
}

export function fmtMoney(n: number): string {
  const sign = n < 0 ? "-" : n > 0 ? "+" : "";
  return `${sign}$${Math.abs(Math.round(n)).toLocaleString()}`;
}

export function clamp(n: number, lo = 0, hi = 100): number {
  return Math.max(lo, Math.min(hi, n));
}